import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { ButtonHook } from 'common/Prose/Toolbar/Types'
import { computed } from 'mobx'
import { undo } from 'prosemirror-history'
import { useContext } from 'react'
import { AlmanacEditorStateContext } from 'stores/EditorState'

export function useUndoToggle(): ButtonHook {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const almanacState = useContext(AlmanacEditorStateContext)!
  const view = useEditorView()

  const disabled = computed(() => !almanacState.undoDepth).get()

  const handleClick = () => undo(view.state, view.dispatch)

  return { active: false, handleClick, disabled }
}
